import { STYLES } from "../game/render/styles";
import { SETTING_ROWS, type ArtStyleId, type ChoiceKey, type SettingRow } from "../game/settings";

/** The line under a pick-one setting's choice: an art style's pitch (it lives with the look), else the row's details. */
export function choiceDetail(key: ChoiceKey, id: string): string | undefined {
  if (key === "artStyle") return STYLES[id as ArtStyleId].pitch;
  const row: SettingRow = SETTING_ROWS[key];
  return row.details?.[id];
}
